import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useCommonAppServices } from 'root/CommonAppServicesContext';

export const PageChangeTracker: React.FC = () => {
  const { trackingService } = useCommonAppServices();
  const location = useLocation();

  useEffect(() => {
    trackingService.pushPageChangeEvent({ url: location.pathname });
  }, [trackingService, location.pathname]);

  return null;
};
